export const notificationData = {
  unReadNotifications: {
    count: 3,
    notifications: [
      {
        notificationId: 101,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User1',
        notificationDate: '01/10/2023',
      },
      {
        notificationId: 102,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User2',
        notificationDate: '02/10/2023',
      },
      {
        notificationId: 103,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User3',
        notificationDate: '02/10/2023',
      },
    ],
  },
  readNotifications: {
    count: 4,
    notifications: [
      {
        notificationId: 51,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User1',
        notificationDate: '01/10/2023',
      },
      {
        notificationId: 52,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User2',
        notificationDate: '02/10/2023',
      },
      {
        notificationId: 53,
        notificationMessage: 'A request to change the password for SFT User Name: SFT_User3',
        notificationDate: '02/10/2023',
      },
    ],
  },
};
